import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import {
  NETWORK_LAYERS,
  STARTUP_SECTIONS
} from '../igmvp_components/models/constants';

import BmcHeader from './BmcHeader';
import Block from './Block';

@injectIntl
@inject('rootStore')
@observer
export default class Show extends React.Component {
  state = { toggledName: '' };

  constructor(props) {
    super(props);

    const { rootStore, history } = props;
    // Activate "thinking mode" only in bmc vision and with an external route /bmc_boards/
    if (
      rootStore.isBmcVision &&
      history.location.pathname.includes('/bmc_boards/')
    ) {
      rootStore.thinkingMode.active = true;
      rootStore.thinkingMode.fetchAllBmcs();
    }

    // The blank slate is active when the route signals that the current
    // section or layer in use is that of PRODUCTS
    const blankSlateKeywords = [
      NETWORK_LAYERS.PRODUCT,
      STARTUP_SECTIONS.INFRASTRUCTURE,
      STARTUP_SECTIONS.MONETIZATION,
      STARTUP_SECTIONS.CUSTOMER_R
    ];
    if (
      blankSlateKeywords.some(keyword =>
        history.location.pathname.includes(keyword)
      )
    ) {
      rootStore.blankSlateMode = true;
    }

    // if (history.location.pathname.includes(blankSlateKeyword)) {
    //     rootStore.blankSlateMode = false;
    // }

    this.canRedirectToStepByStep =
      rootStore.authorizationStore.canRedirectToStepByStep;
  }

  toggleWideScreen = _toggledName => {
    const { toggledName } = this.state;

    if (toggledName === _toggledName) {
      this.setState({ toggledName: null });
    } else this.setState({ toggledName: _toggledName });
  };

  render() {
    const { intl, rootStore, history } = this.props;
    const { toggledName } = this.state;

    // TODO: redirect always to step by step? ///////////////////////////////////////////////////////////
    if (rootStore.oneBlockMode.active) {
      const blockStore = rootStore.getBlockStoreByName(
        rootStore.oneBlockMode.name
      );

      return (
        <div className="react-board">
          <BmcHeader modal={this.props.modal} />
          <div
            className="col-md-8 col-md-push-2 bmc-col-lane"
            style={{ paddingBottom: '25px' }}
          >
            <Block blockStore={blockStore} key={blockStore.id} />
          </div>
        </div>
      );
    }

    if (toggledName) {
      const blockStore = rootStore.getBlockStoreByName(toggledName);

      return (
        <div className="react-board">
          <BmcHeader modal={this.props.modal} />
          <div
            className="col-md-10 col-md-push-1 bmc-col-lane"
            style={{ paddingBottom: '25px' }}
          >
            <Block
              blockStore={blockStore}
              toggleWideScreen={this.toggleWideScreen}
              toggled={!!toggledName}
              key={blockStore.id}
            />
          </div>
        </div>
      );
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////

    const kPropositionBlockStore = rootStore.getKeyPropositionBlockStore;
    const customerSBlockStore = rootStore.getCustomerSegmentBlockStore;
    const cRBlockStore = rootStore.getCustomerRelationshipBlockStore;
    const cHBlockStore = rootStore.getChannelBlockStore;
    const kABlockStore = rootStore.getKeyActivitiesBlockStore;
    const kRBlockStore = rootStore.getKeyResourcesBlockStore;
    const kPartnerBlockStore = rootStore.getKeyPartnersBlockStore;
    const costSBlockStore = rootStore.getCostStructureBlockStore;
    const rSBlockStore = rootStore.getRevenueStreamBlockStore;

    // if there is no cards redirect to the interactive mode
    /*
        if (this.canRedirectToStepByStep) {
            return (<Redirect to={`${history.location.pathname}/step_mode/${rootStore.stepByStepBlock}`} push={true}/>);
        }
        */

    return (
      <div className="react-board">
        <BmcHeader modal={this.props.modal} />

        <Row className="bmc-row-container">
          <div className="col-md-2-4 col-md-push-4-8 col-xs-12 bmc-col-lane">
            <Block
              toggleWideScreen={this.toggleWideScreen}
              blockStore={kPropositionBlockStore}
              key={kPropositionBlockStore.id}
            />
          </div>

          <div className="col-md-2-4 col-md-push-7-2 col-xs-12 bmc-col-lane">
            <Block
              toggleWideScreen={this.toggleWideScreen}
              blockStore={customerSBlockStore}
              key={customerSBlockStore.id}
            />
          </div>

          <div className="col-md-2-4 col-md-push-2-4 col-xs-12 bmc-col-lane">
            <Row>
              <Block
                toggleWideScreen={this.toggleWideScreen}
                blockStore={cRBlockStore}
                key={cRBlockStore.id}
              />
              <Block
                toggleWideScreen={this.toggleWideScreen}
                blockStore={cHBlockStore}
                key={cHBlockStore.id}
              />
            </Row>
          </div>

          <div className="col-md-2-4 col-md-pull-4-8 col-xs-12 bmc-col-lane">
            <Row>
              <Block
                toggleWideScreen={this.toggleWideScreen}
                blockStore={kABlockStore}
                key={kABlockStore.id}
              />
              <Block
                toggleWideScreen={this.toggleWideScreen}
                blockStore={kRBlockStore}
                key={kRBlockStore.id}
              />
            </Row>
          </div>

          <div className="col-md-2-4 col-md-pull-9-6 col-xs-12  bmc-col-lane ">
            <Block
              toggleWideScreen={this.toggleWideScreen}
              blockStore={kPartnerBlockStore}
              key={kPartnerBlockStore.id}
            />
          </div>
        </Row>

        <Row>
          <div className="col-md-6 col-xs-12 bmc-col-lane">
            <Block
              toggleWideScreen={this.toggleWideScreen}
              blockStore={costSBlockStore}
              key={costSBlockStore.id}
            />
          </div>
          <div className="col-md-6  col-xs-12 bmc-col-lane">
            <Block
              toggleWideScreen={this.toggleWideScreen}
              blockStore={rSBlockStore}
              key={rSBlockStore.id}
            />
          </div>
        </Row>
      </div>
    );
  }
}

Show.propTypes = {};
